import styled from 'styled-components'
import FolderIcon from '../../../icons/IconLib/FolderIcon'

type Props = {
  message?: string
}

const EmptyMessage = ({ message = 'אין נתונים להצגה' }: Props) => (
  <Wrapper role="status" aria-live="polite">
    <IconWrapper>
      <FolderIcon />
    </IconWrapper>
    <Title>לא נמצאו רשומות</Title>
    <Subtitle>{message}</Subtitle>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6em;
  padding: 2.4em 1.5em;
  direction: rtl;
`

const IconWrapper = styled.div`
  width: 3.6em;
  height: 3.6em;
  border-radius: 50%;
  background: #f0f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  color: #8a9ab0;
  margin-bottom: 0.2em;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`

const Title = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: #2d3a4a;
  margin: 0;
`

const Subtitle = styled.p`
  font-size: 0.82rem;
  color: #8a9ab0;
  margin: 0;
  text-align: center;
`

export default EmptyMessage
